import React, { useState, useEffect, } from "react";
import { useSelector } from "react-redux";
import classes from "./Chat.module.css";
import Messages from "./Messages/Messages";
import {
  selectChannelId,
  // selectChannelName,
} from "../../../store/reducers/appSlice";
import { selectCharacter } from "../../../store/reducers/characterSlice";
import db from "../../../firebase/firebase";
import { sendMessage } from "../../../hooks/SendMessage/SendMessage";
import Portrait from "../../../hooks/Portrait/Portrait";


// import RichEditor from './Editor/Editor'
import RichEditor from "./Editor/Editor";


function Chat() {
  const character = useSelector(selectCharacter);
  const channelId = useSelector(selectChannelId);
  // const channelName = useSelector(selectChannelName);
  // const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  // const [sentMessages, setSentMessages] = useState([]);
  // const [cursor, setCursor] = useState(0);
  // const [legacy, setLegacy] = useState(false);

  useEffect(() => {
    if (channelId) {
      const unsubscribe = db
        .collection("channels")
        .doc(channelId)
        .collection("messages")
        .orderBy("timestamp", "asc")
        .limitToLast(50)
        .onSnapshot((snapshot) => {
          setMessages(snapshot.docs.map((doc) => doc.data()));
        });
      return () => {
        unsubscribe();
      };
    }
  }, [channelId]);

  // const onKeyPressHandler = (e) => {
  //   let position = cursor;
  //   let prevMessages = ["", ...sentMessages];

  //   if (
  //     e.keyCode === 38 &&
  //     prevMessages.length > 1 &&
  //     position < prevMessages.length - 1
  //   ) {
  //     position = position + 1;
  //     setInput(prevMessages[position]);
  //   }
  //   if (e.keyCode === 40 && prevMessages.length > 1 && position > 0) {
  //     position = position - 1;
  //     setInput(prevMessages[position]);
  //   }
  //   setCursor(position);
  // };
  // const onSendMessageHandler = (e) => {
  //   e.preventDefault();
  //   let messageData = {
  //     blocks: [
  //       {
  //         key: Math.floor(Math.random() * 90000) + 10000,
  //         text: input,
  //         type: "unstyled",
  //         depth: 0,
  //         inlineStyleRanges: [],
  //         entityRanges: [],
  //         data: {},
  //       },
  //     ],
  //     entityMap: {},
  //   };
  //   let message = JSON.stringify(messageData);
  //   sendMessage(message, character, channelId);
  //   setSentMessages((sentMessages) => [input, ...sentMessages]);
  //   setInput("");
  //   setCursor(0);
  // };

  // const onLegacyClickHandler = () => {
  //   setLegacy(!legacy);
  // }
  const onMacroClickHandler = (macro) => {
    let messageData = {
      blocks: [
        {
          key: Math.floor(Math.random() * 90000) + 10000,
          text: macro,
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
    };
    let message = JSON.stringify(messageData);
    sendMessage(message, character, channelId);
    // setSentMessages((sentMessages) => [macro, ...sentMessages]);
  };

  const sendChatMessage = (content) => {
    sendMessage(content, character, channelId);
    // setSentMessages(sentMessages => [content, ...sentMessages])
  };

  let chatScreen = <div> </div>;
  let chatMessages = <div> </div>;
  let editor = (
    <div>
      <RichEditor
        className={classes.chat__input}
        channelId={channelId}
        sendMessage={sendChatMessage}
      />
    </div>
  );

  // if (legacy) {
  //   editor = (
  //     <form className={classes.chat__input} onSubmit={onSendMessageHandler}>
  //       <input
  //         value={input}
  //         disabled={!channelId}
  //         onChange={(e) => setInput(e.target.value)}
  //         placeholder={`Send a message to #${channelName}`}
  //         onKeyDown={onKeyPressHandler}
  //       />
  //       <button
  //         className={classes.chat__inputButton}
  //         disabled={!channelId}
  //         type="submit"
  //         //onClick={onSendMessageHandler}
  //       >
  //         Send Message
  //       </button>
  //     </form>
  //   );
  // }

  if (channelId && character.activeCharacter) {
    chatMessages = (
      <div className={classes.chat__messages}>
        <Messages messages={messages} />
      </div>
    );
    chatScreen = (
      <div>

        {/* <Button onClick={onLegacyClickHandler}> {legacy ? "Modern":"Legacy"} </Button> */}
        <div className={classes.avatarContainer}>
          <div className={classes.avatar}>
            <Portrait character={character.character.character} />
          </div>
        </div>

        <div className={classes.macro__wallet}>
          <span
            onClick={() => {
              if (character.character.character.macro1) {
                onMacroClickHandler(character.character.character.macro1);
              }
            }}
          >
            <img
              className={classes.macro}
              src={character.character.character.macro1Icon}
              id="macro1Icon"
              alt="macro icon"
            />
          </span>
          {/* JFW done profile key code - replicate in here and test */}

          <span
            onClick={() => {
              if (character.character.character.macro2) {
                onMacroClickHandler(character.character.character.macro2);
              }
            }}
          >
            <img
              className={classes.macro}
              src={character.character.character.macro2Icon}
              id="macro2Icon"
              alt="macro icon"
            />
          </span>
          <span
            onClick={() => {
              if (character.character.character.macro3) {
                onMacroClickHandler(character.character.character.macro3);
              }
            }}
          >
            <img
              className={classes.macro}
              src={character.character.character.macro3Icon}
              id="macro3Icon"
              alt="macro icon"
            />
          </span>
        </div>

        <div className={classes.chat__input}>{editor}</div>
      </div>
    );
  }

  return (
    <div className={classes.chat}>
      {/* <ChatHeader channelName={channelName} /> */}
      {chatMessages}
      {chatScreen}
    </div>
  );
}

export default Chat;
